/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DlsgPolicyConfig } from '../models/DlsgPolicyConfig';
import { HighFrequencyBackupSchedules } from '../models/HighFrequencyBackupSchedules';
import { ResourceType } from '../models/ResourceType';

export class DlsgPolicyPlan {
  /**
  * Resource types to backup (only AWS_S3 is supported for DLSG).
  */
  'resourceTypes': Array<ResourceType>;
  'backupSchedule': HighFrequencyBackupSchedules;
  /**
  * Whether dlsg client-side deployment is enabled for resource associated with this policy.
  */
  'enableClientSideDeployment'?: boolean;
  /**
  * List of IAM principals (ARNs) allowed to access vault data for client-side deployment. 
  */
  'clientSideDeploymentAllowedPrincipals'?: Array<string>;
  /**
  * Whether deletion manifest is enabled for resources associated with this policy.
  */
  'enableDeletionManifest'?: boolean;
  /**
  * List of IAM principals (ARNs) allowed to access deletion manifest data. 
  */
  'deletionManifestAllowedPrincipals'?: Array<string>;
  /**
  * configuration for DLSG policies. This includes path prefixes, migration delay, and data truncation settings. 
  */
  'dlsgConfig': Array<DlsgPolicyConfig>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceTypes",
      "baseName": "resourceTypes",
      "type": "Array<ResourceType>",
      "format": ""
    },
    {
      "name": "backupSchedule",
      "baseName": "backupSchedule",
      "type": "HighFrequencyBackupSchedules",
      "format": ""
    },
    {
      "name": "enableClientSideDeployment",
      "baseName": "enableClientSideDeployment",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "clientSideDeploymentAllowedPrincipals",
      "baseName": "clientSideDeploymentAllowedPrincipals",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "enableDeletionManifest",
      "baseName": "enableDeletionManifest",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "deletionManifestAllowedPrincipals",
      "baseName": "deletionManifestAllowedPrincipals",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "dlsgConfig",
      "baseName": "dlsgConfig",
      "type": "Array<DlsgPolicyConfig>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DlsgPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}

